import { Component, Vue } from 'vue-property-decorator';
import AccessToken from '@/services/access_token.ts';
import store from '@/store';

@Component({})
export default class Login extends Vue {
  payload = {
    email: '',
    password: ''
  }
  accessTokenService = new AccessToken();
  isError = false;
  isLoading = false;

  mounted() {
    const accessToken = localStorage.getItem('token');

    if (accessToken) {
      const redirect = new URL(location.href).searchParams.get('returnUrl');
      this.$router.push(redirect ? redirect : '/');
    }
  }

  async login() {
    this.isLoading = true;
    try {
      this.isLoading = true;
      const loginData: any = await this.accessTokenService.create(this.payload);
      localStorage.setItem('token', loginData.access_token)
      localStorage.setItem('email', loginData.user.email)
      
      store.commit('loginSuccess')
      this.isLoading = false;
    } catch {
      this.isError = true;
    } finally {
      this.isLoading = false;
    }
  }
}

